<template>
  <div class="grid pb-0">
    <div class="grid-body border-top-unset" style="height: calc(100vh - 143px);">
      <div class="body-room-sale">
        <v-card-text id="card-search">
          <v-row align="center">
            <v-col sm="3" class="pt-0 pb-0">
              <label class="pr-0">
                {{ $t("ROOM_TYPE") }}
              </label>
              <v-autocomplete item-text="text" item-value="value" :items="listRoom" v-model="selectedRoomCalendar"
                outlined dense @change="changeSearchCondition(selectedRoom)">
                <template slot="no-data">
                  <div class="no-data">{{ $t("NO_DATA") }}</div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col sm="2" class="pt-0 pb-0">
              <label>
                {{ $t("SALE_PACKAGE") }}
              </label>
              <v-autocomplete item-text="text" item-value="value" :items="calendarListSalePackage"
                v-model="calendarCurrentSalePackage" outlined dense>
                <template slot="no-data">
                  <div class="no-data">{{ $t("NO_DATA") }}</div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col sm="2" class="pt-0 pb-0">
              <label>
                {{ $t("SALE_CHANNEL") }}
              </label>
              <v-autocomplete item-text="text" item-value="value" :items="listOTA" v-model="selectedOTA" outlined dense
                @change="changeSearchCondition(selectedOTA)">
                <template slot="no-data">
                  <div class="no-data">{{ $t("NO_DATA") }}</div>
                </template>
              </v-autocomplete>
            </v-col>
            
            <v-col sm="2" class="pt-0 pb-0">
              <label>
                {{ $t("VIEW") }}
              </label>
              <v-autocomplete item-text="text" item-value="value" :items="optionTableSelect" v-model="tableSelect"
                outlined dense></v-autocomplete>
            </v-col>
          </v-row>
          <template v-if="isLoading == false">
            <v-alert
              dense
              text
              color="error"
              type="error"
              @input="onResize"
              class="mt-3 mb-0"
              v-if="listOTA.find(e => e.value === selectedOTA).date < 15"
            >
            <span class="text-center fs-14" v-if="listOTA.find(e => e.value === selectedOTA).date > 0 &&
              listOTA.find(e => e.value === selectedOTA).date < 15
              ">
              {{
                $t("TEXT_NOTIFY_WILL_EXPIRE", {
                  channel: listOTA.find(e => e.value === selectedOTA).text,
                  date: listOTA.find(e => e.value === selectedOTA).endDate
                })
              }}
            </span>
            <span class="text-center fs-14" v-if="listOTA.find(e => e.value === selectedOTA).date <= 0">
              {{
                $t("TEXT_NOTIFY_EXPIRED", {
                  channel: listOTA.find(e => e.value === selectedOTA).text,
                  date: listOTA.find(e => e.value === selectedOTA).endDate
                })
              }}
            </span>
            </v-alert>
            
          </template>
        </v-card-text>
        
        <v-sheet v-if="!isLoading">
        <div class="d-tbl-full-year">
            <table class="tbl-full-year">
            <tr>
                <th class="th-year">{{ currentYear }}</th>
                <th v-for="(i, day) in 31" class="th-day" :key="'day_'+day">{{ i }}</th>
            </tr>
            <tr v-for="(month, keyMonth) in 12" :key="'keyMonth_'+keyMonth">
                <td class="qcont td-month">{{ $t("TH" + month) }}</td>
                <template v-if="tableSelect === 'PRICE'">
                <td class="td-day" v-for="(d, tdDay) in daysOfMonths[month - 1]"
                    :class="new Date(currentYear, month - 1, d + 1) < new Date()
                        ? 'td-opacity'
                        : checkWeekend(`${currentYear}-${month < 10 ? '0' + month : month}-${d < 10 ? '0' + d : d}`)"
                    :key="'tdDay'+tdDay"
                >
                    <template v-if="calendarRate[0].ratePlans.length > 0 &&
                    calendarRate[0].ratePlans
                        .find(x => x.id == calendarCurrentSalePackage)
                        .restrictions.filter(
                        y =>
                            y.appliedDate ==
                            `${currentYear}-${month < 10 ? '0' + month : month
                            }-${d < 10 ? '0' + d : d}` &&
                            y.closed === true
                        ).length > 0
                    ">
                    <div class="d-stop"></div>
                    </template>
                    <template v-else-if="calendarRate[0].ratePlans.length > 0 &&
                    calendarRate[0].ratePlans
                        .find(x => x.id == calendarCurrentSalePackage)
                        .roomRates[0]['roomRateSpecials'].filter(
                        y =>
                            y.appliedDate ==
                            `${currentYear}-${month < 10 ? '0' + month : month
                            }-${d < 10 ? '0' + d : d}`
                        ).length > 0 &&
                    calendarRate[0].ratePlans
                        .find(x => x.id == calendarCurrentSalePackage)
                        .roomRates[0]['roomRateSpecials'].find(
                        z =>
                            z.appliedDate ==
                            `${currentYear}-${month < 10 ? '0' + month : month
                            }-${d < 10 ? '0' + d : d}`
                        ).pricePax != -1
                    ">
                    <div class="d-date d-special fs-10">
                        <span :class="parseRoomRateSpecial(calendarRate[0].ratePlans
                        .find(x => x.id == calendarCurrentSalePackage)
                        .roomRates[0]['roomRateSpecials'].find(
                            z =>
                            z.appliedDate ==
                            `${currentYear}-${month < 10 ? '0' + month : month
                            }-${d < 10 ? '0' + d : d}`
                        ).priceBy)">{{
priceFormat(
    calendarRate[0].ratePlans
    .find(
        x => x.id == calendarCurrentSalePackage
    )
    .roomRates[0]["roomRateSpecials"].find(
        z =>
        z.appliedDate ==
        `${currentYear}-${month < 10 ? "0" + month : month}-${d < 10 ? "0" + d : d}`).pricePax)
}}</span>
                            <div class="d-icon-delete" @click="
                            $refs.deleteSpecialPriceDialogComponent.open({
                            roomTypeId: selectedRoomCalendar,
                            ratePlanId: calendarCurrentSalePackage,
                            date: `${currentYear}-${month < 10 ? '0' + month : month
                                }-${d < 10 ? '0' + d : d}`
                            })
                            ">
                            <v-icon light size="20" color="red">delete</v-icon>
                            </div>
                            <span class="closedOnArrival" v-if="calendarRate[0].ratePlans
                            .find(
                                x => x.id == calendarCurrentSalePackage
                            )
                            .restrictions.filter(
                                y =>
                                y.appliedDate ==
                                `${currentYear}-${month < 10 ? '0' + month : month
                                }-${d < 10 ? '0' + d : d}` &&
                                y.closedOnArrival === true
                            ).length > 0
                            "></span>
                            <span class="closedOnDeparture" v-if="calendarRate[0].ratePlans
                            .find(
                                x => x.id == calendarCurrentSalePackage
                            )
                            .restrictions.filter(
                                y =>
                                y.appliedDate ==
                                `${currentYear}-${month < 10 ? '0' + month : month
                                }-${d < 10 ? '0' + d : d}` &&
                                y.closedOnDeparture === true
                            ).length > 0
                            "></span>
                    </div>
                    </template>
                    <template v-else-if="calendarRate[0].ratePlans.length > 0">
                    <div class="d-date d-non-special p-1" :class="calendarRate[0].ratePlans.find(
                        x => x.id == calendarCurrentSalePackage
                    ).roomRates[0].linkedRoomRateId ? 'text-master-rate' : ''">
                        <span>
                        {{
                            priceFormat(
                            calendarRate[0].ratePlans.find(
                                x => x.id == calendarCurrentSalePackage
                            ).roomRates[0][
                            formatDateOfWeekInPrice(
                                new Date(currentYear, month - 1, d)
                            )
                            ]
                            )
                        }}</span>
                        <span class="closedOnArrival" v-if="calendarRate[0].ratePlans
                            .find(
                                x => x.id == calendarCurrentSalePackage
                            )
                            .restrictions.filter(
                                y =>
                                y.appliedDate ==
                                `${currentYear}-${month < 10 ? '0' + month : month
                                }-${d < 10 ? '0' + d : d}` &&
                                y.closedOnArrival === true
                            ).length > 0
                            "></span>
                        <span class="closedOnDeparture" v-if="calendarRate[0].ratePlans
                        .find(
                            x => x.id == calendarCurrentSalePackage
                        )
                        .restrictions.filter(
                            y =>
                            y.appliedDate ==
                            `${currentYear}-${month < 10 ? '0' + month : month
                            }-${d < 10 ? '0' + d : d}` &&
                            y.closedOnDeparture === true
                        ).length > 0
                        "></span>
                    </div>
                    </template>
                </td>
                </template>
                <template v-if="tableSelect === 'AVAILABLE_ROOM'">
                <td 
                    class="td-day" v-for="(d, AVAILABLE_ROOM) in daysOfMonths[month - 1]" 
                    :class="new Date(currentYear, month - 1, d + 1) < new Date()
                        ? 'td-opacity'
                        : ''
                    "
                    :key="'AVAILABLE_ROOM_'+AVAILABLE_ROOM" 
                >
                    <template v-if="calendarRate[0].availabilities.find(
                    x =>
                        x.appliedDate ==
                        `${currentYear}-${month < 10 ? '0' + month : month
                        }-${d < 10 ? '0' + d : d}`
                    )
                    ">
                    <div :class="+calendarRate[0].availabilities.find(
                        x =>
                        x.appliedDate ==
                        `${currentYear}-${month < 10 ? '0' + month : month
                        }-${d < 10 ? '0' + d : d}`
                    ).quantity > 20
                        ? 'd-date fs-10 p-1 d-most'
                        : +calendarRate[0].availabilities.find(
                        x =>
                            x.appliedDate ==
                            `${currentYear}-${month < 10 ? '0' + month : month
                            }-${d < 10 ? '0' + d : d}`
                        ).quantity >= 10 &&
                        +calendarRate[0].availabilities.find(
                            x =>
                            x.appliedDate ==
                            `${currentYear}-${month < 10 ? '0' + month : month
                            }-${d < 10 ? '0' + d : d}`
                        ).quantity <= 20
                        ? 'd-date fs-10 p-1 d-much'
                        : 'd-date fs-10 p-1 d-little'
                        ">
                        {{
                        calendarRate[0].availabilities.find(
                            x =>
                            x.appliedDate ==
                            `${currentYear}-${month < 10 ? "0" + month : month}-${d < 10 ? "0" + d : d}`).quantity }} </div>
                    </template>
                </td>
                </template>
            </tr>
            </table>
        </div>
        <div class="w-100">
            <v-sheet tile class="d-flex w-100">
            <v-toolbar flat class="w-100">
                <ul v-if="tableSelect === 'PRICE'" class="tools-icon-description mr-auto">
                <li>
                    <span class="i-square bg-stopSell"></span>
                    {{ $t("closed") }}
                </li>
                <li>
                    <span class="i-square d-weekend"></span>
                    {{ $t("WEEKEND") }}
                </li>
                <li>
                    <i class="pr-1 icon-delete text-danger fs-16"></i>
                    {{ $t("REMOVE_SPECIAL_PRICE") }}
                </li>
                <li>
                    <span class="i-square">
                    <i class="close-before"></i>
                    </span>
                    {{ $t("closedOnArrival") }}
                </li>
                <li>
                    <span class="i-square">
                    <i class="close-after"></i>
                    </span>
                    {{ $t("closedOnDeparture") }}
                </li>
                <li>
                    <span class="font-weight-bold">000</span>
                    {{ $t("DAILY_PRICE") }}
                </li>
                <li>
                    <span class="text-smart font-weight-bold">000</span>
                    {{ $t("DYNAMIC_PRICING") }}
                </li>
                <li>
                    <span class="text-master-rate">000</span>
                    {{ $t("MASTER_RATE") }}
                </li>
                <li>
                    <span class="text-master-rate font-weight-bold">000</span>
                    {{ $t("DAILY_MASTER_RATE") }}
                </li>
                </ul>
                <ul v-if="tableSelect === 'AVAILABLE_ROOM'" class="tools-icon-description mr-auto">
                <li>
                    <span class="i-square d-little" style="border-radius: 2px"> &lt; 10 </span>
                        <span class="i-square d-much" style="border-radius: 2px">10 - 20</span>
                        <span class="i-square d-most" style="border-radius: 2px"> &gt; 20</span>
                        {{ $t("ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE") }}
                </li>
                </ul>
                <div class="d-flex align-items-center">
                <v-btn icon class="ma-2" @click="currentYear--">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-toolbar-title class="fs-12 qcont">{{ $t("YEARS") }} {{ currentYear }}</v-toolbar-title>
                <v-btn icon class="ma-2" @click="currentYear++">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                </div>
            </v-toolbar>
            </v-sheet>
        </div>
        </v-sheet>
        <div class="text-center" v-if="isLoading">
        <img src="@/assets/loading-logo-animation.gif" style="width: 75px" />

        <p class="font-weight-bold">{{ $t('THE_SYSTEM_IS_LOADING') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.special-price+div {
  display: none;
}

.add-person {
  padding-left: 10px;
  z-index: 99999999;
}

.delete-person {
  padding-left: 10px;
  z-index: 99999999;
}

.copy-price {
  left: -8px;
  top: 8px;
  position: absolute;
  z-index: 99999999;
}

.tab-header {
  background-color: #fff;
  padding: 25px 15px 10px 15px;
}

.restriction-ota {
  font-size: 14px;

  h6 {
    font-size: 14px;

    &.room-title {
      background: #f0f0f0;
      padding: 10px;
      margin: 0;
      border-radius: 5px;
    }
  }

  .sale-package-info {
    align-items: center;
    border-bottom: 1px solid #dedddd;
    padding-bottom: 5px;
  }

  .col-md-12:last-child {
    .sale-package-info {
      border-bottom: none;
    }
  }
}
</style>

<script>
import { _alert } from "@/_helpers/function.js";
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { service } from "@/_services/SaleRoom/room-plan.service.js";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";

import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import moment from "moment";
import { categoryService } from "@/_services/SaleRoom/category.service.js";

export default {
  data() {
    return {
      isNote: true,
      syncPMS: JSON.parse(localStorage.getItem("currentUser")).hotel.syncPMS,
      syncInventory: JSON.parse(localStorage.getItem("currentUser")).hotel.syncInventory,
      maxHeight: 430,
      weekend: ["WED", "THU", "FRI", "SAT", "SUN", "TUE", "MON"],
      defaultWeekend: [],
      dateList: [],
      isLoading: true,
      systemLang: this.$i18n.locale,
      selectedRoom: [], // Phòng đang được sửa
      selectedRoomCalendar: -1,
      listRoom: [], // Danh sách các phòng, do dữ liệu roomData cấu thành list
      relationData: [], // Thông tin gói bán và giá của tất cả phòng do API trả về
      currentDate: moment()
        .startOf("day")
        .toDate(),
      maxDate: moment(this.currentDate)
        .add(2, "year")
        .add(14, "day")
        .format("YYYY-MM-DD"),
      listOTA: [],
      selectedOTA: null,
      selectedDatePicker: null,
      popupSalePackage: {
        addSalePackageDialog: false,
        listSalePackageDefault: [],
        listSalePackage: [],
        selectedSalePackage: [],
        roomTypeId: null,
        isLoading: false,
      },
      calendarCurrentMonthYear: moment()
        .startOf("day")
        .format("YYYY-MM"),
      calendarCurrentSalePackage: "-1",
      calendarRate: null,
      calendarListSalePackage: [],
      currentYear: new Date().getFullYear(),
      tableSelect: "PRICE",
      optionTableSelect: [
        {
          text: this.$t("_BATCH_UPDATE.PRICE"),
          value: "PRICE"
        },
        {
          text: this.$t("_BATCH_UPDATE.AVAILABLE_ROOM"),
          value: "AVAILABLE_ROOM"
        }
      ],
      weekend: [],
      selectedSalePackage: [],
      listRateCategory: [],
      listRatePlanByRateCategory: [],
      changeSelect: false,
      isOpen: false,
      listRoomTypeByRoomCategory: [],
      listRoomCategory: [],
      otaCodeEdit: null,
    };
  },
  computed: {
    daysOfMonths() {
      return [
        31,
        this.isLeapYear() ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ];
    },
  },
  created() {
    this.initialize(false);
  },
  watch: {
    currentYear() {
      this.getRateCalendar(false);
    },
    selectedDatePicker() {
      this.currentDate = this.selectedDatePicker;
      this.getRelation(true);
    },
    calendarCurrentMonthYear() {
      this.getRateCalendar(false);
    },
    selectedSalePackage() {
      if (this.selectedSalePackage.length === 0 && this.isOpen === false) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.changeSearchCondition(true);
        }, 1000);
        this.changeSelect = false;
      } else {
        this.changeSelect = true;
      }
    },
    selectedRoom() {
      if (this.selectedRoom.length === 0 && this.isOpen === false) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.changeSearchCondition(true);
        }, 1000);
        this.changeSelect = false;
      } else {
        this.changeSelect = true;
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    parseRoomRateSpecial(value) {
      switch (value) {
        case 0:
          return 'font-weight-bold'
        case 1:
          return 'font-weight-bold text-smart'
        case 2:
          return 'font-weight-bold text-master-rate'
        default:
          return '';
      }
    },
    isLeapYear() {
      return (
        this.currentYear % 400 === 0 ||
        (this.currentYear % 100 !== 0 && this.currentYear % 4 === 0)
      );
    },
    getRateCalendar(useFirstRoom) {
      this.isLoading = true;
      // Reset lai data cua lich
      this.calendarListSalePackage = [];
      this.calendarRate = [];
      // List phòng dùng chung với dạng bảng, neu dang chon tat ca phong thi khi chuyen tab, chon phong dau tien
      if (this.selectedRoomCalendar == "-1") {
        this.selectedRoomCalendar = this.listRoom[0].value;
      }

      let body = {
        roomIds:
          this.selectedRoomCalendar == "-1"
            ? [this.listRoom[0].value]
            : [this.selectedRoomCalendar],
        // year: moment(this.calendarCurrentMonthYear).format("YYYY"),
        year: this.currentYear,
        // month: moment(this.calendarCurrentMonthYear).format("MM"),
        month: null,
        ota: this.selectedOTA
      };

      service
        .getDetailRoomRate(body)
        .then(res => {
          if (res.responseCode === 0) {
            // Lấy data hiển thị cho table
            this.calendarRate = [...res.data];
            // // console.log(this.calendarRate);
            // Lấy danh sách gói bán của phòng hiện tại, mặc định là gói đầu tiên được chọn nên ko có trường hợp mảng lớn hơn 1
            this.calendarListSalePackage = res.data[0].ratePlans.map(x => {
              return {
                value: x.id,
                text: x.i18ns.find(y => y.lang == this.defaultI18n).name
              };
            });
            this.calendarListSalePackage = this.calendarListSalePackage.filter(
              x => x.value
            );
            if (useFirstRoom) {
              this.calendarCurrentSalePackage = this.calendarListSalePackage[0].value;
            }
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    onResize() {
      const cardSearchElement = document.getElementById('card-search');
    
        if (!cardSearchElement) {
          console.error('Không tìm thấy thẻ div với id là "card-search"');
          return;
        }

        const resizeObserver = new ResizeObserver(entries => {
          for (const entry of entries) {
            const { target, contentRect } = entry;
            this.maxHeight = window.innerHeight - 60 - 70 - 50 - contentRect.height - 60;
          }
        });
        resizeObserver.observe(cardSearchElement);
        this.$once('hook:beforeDestroy', () => {
          resizeObserver.unobserve(cardSearchElement);
        });
      
    },
    formatDateOfWeekInPrice(date) {
      let dayOfWeek;
      switch (moment(date).day()) {
        case 0: {
          dayOfWeek = "paxSunday";
          break;
        }
        case 1: {
          dayOfWeek = "paxMonday";
          break;
        }
        case 2: {
          dayOfWeek = "paxTuesday";
          break;
        }
        case 3: {
          dayOfWeek = "paxWednesday";
          break;
        }
        case 4: {
          dayOfWeek = "paxThursday";
          break;
        }
        case 5: {
          dayOfWeek = "paxFriday";
          break;
        }
        case 6: {
          dayOfWeek = "paxSaturday";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDateOfWeek(date) {
      let dayOfWeek;
      switch (date.day()) {
        case 0: {
          dayOfWeek = "SUN";
          break;
        }
        case 1: {
          dayOfWeek = "MON";
          break;
        }
        case 2: {
          dayOfWeek = "TUE";
          break;
        }
        case 3: {
          dayOfWeek = "WED";
          break;
        }
        case 4: {
          dayOfWeek = "THU";
          break;
        }
        case 5: {
          dayOfWeek = "FRI";
          break;
        }
        case 6: {
          dayOfWeek = "SAT";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDate(date) {
      var currentDate = moment(date, "YYYY-MM-DD");
      if (!currentDate.isValid()) {
        return "";
      }
      let dayOfWeek = "";
      switch (currentDate.day()) {
        case 0: {
          dayOfWeek = this.$t("SUN_SHORT").toString();
          break;
        }
        case 1: {
          dayOfWeek = this.$t("MON_SHORT").toString();
          break;
        }
        case 2: {
          dayOfWeek = this.$t("TUE_SHORT").toString();
          break;
        }
        case 3: {
          dayOfWeek = this.$t("WED_SHORT").toString();
          break;
        }
        case 4: {
          dayOfWeek = this.$t("THU_SHORT").toString();
          break;
        }
        case 5: {
          dayOfWeek = this.$t("FRI_SHORT").toString();
          break;
        }
        case 6: {
          dayOfWeek = this.$t("SAT_SHORT").toString();
          break;
        }
      }
      return (
        '<div class="day-week">' +
        dayOfWeek +
        '</div><div class="day-day font-weight-bold">' +
        currentDate.format("DD") +
        '</div><div class="day-month">' +
        this.$t(currentDate.format("MMM").toUpperCase() + "_SHORT") +
        "</div>"
      );
    },
    loadDateList() {
      let hotelWeekend = JSON.parse(localStorage.getItem("hotelWeekend"));
      // Chuyển từ binary sang select
      this.defaultWeekend = this.convertFromBinaryToListSelection(hotelWeekend);
      var tmp = [];
      this.defaultWeekend.forEach(function (element, index) {
        if (element == 1) {
          if (index == 0) {
            tmp.push("MON");
          }
          if (index == 1) {
            tmp.push("TUE");
          }
          if (index == 2) {
            tmp.push("WED");
          }
          if (index == 3) {
            tmp.push("THU");
          }
          if (index == 4) {
            tmp.push("FRI");
          }
          if (index == 5) {
            tmp.push("SAT");
          }
          if (index == 6) {
            tmp.push("SUN");
          }
        }
      });
      this.weekend = tmp
      var currentDate = moment(this.currentDate);
      this.dateList = [];
      for (let i = 0; i < 31; i++) {
        var isWeekend =
          tmp.indexOf(currentDate.format("ddd").toUpperCase()) > -1;
        this.dateList.push({
          date: currentDate.format("YYYY-MM-DD"),
          isWeekend: isWeekend
        });
        currentDate.add(1, "day");
      }
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    async initialize(isSearch) {
      this.isLoading = true;
      this.otaCodeEdit = JSON.parse(localStorage.getItem("currentOTACodeEdit"))
      Promise.all([
        this.getSalePackage(),
        this.getAllRateCategory(),
        this.getOta(isSearch)
      ]).then(() => {
        this.getRelation();
        this.getRateCalendar(true);
      })
    },
    async getRelation(isSearch = false) {
      var fromDate = this.selectedDatePicker;
      var toDate = moment(this.selectedDatePicker)
        .add(30, "day")
        .format("YYYY-MM-DD");

      this.loadDateList();
      var ratePlanIds = [];
      this.selectedSalePackage.forEach(e => {
        if (this.listRateCategory.includes(e) || e == -1) {
          var arrPlanIds = this.listRatePlanByRateCategory.find(item => item.id === e).children.map(c => c.id);
          ratePlanIds = ratePlanIds.concat(arrPlanIds)
        } else {
          ratePlanIds.push(e)
        }
      })
      var roomTypeIds = [];
      this.selectedRoom.forEach(e => {
        if (this.listRoomCategory.includes(e) || e == -1) {
          var arrRoomIds = this.listRoomTypeByRoomCategory.find(item => item.id === e).children.map(c => c.id);
          roomTypeIds = roomTypeIds.concat(arrRoomIds)
        } else {
          roomTypeIds.push(e)
        }
      })

      let body = {
        from: fromDate,
        to: toDate,
        roomTypeIds: roomTypeIds.length > 0 ? [...roomTypeIds] : [],
        ratePlanIds: ratePlanIds.length > 0 ? [...ratePlanIds] : [],
        otaId: this.selectedOTA,
        rateCategoryIds: []
      };
      const queryString = window.location.href;
     const ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
      localStorage.setItem(
        "roomCalendarSearch",
        JSON.stringify({
          hotelId: ob.hotel.id,
          from: this.selectedDatePicker,
          selectedSalePackage: this.selectedSalePackage,
          selectedRoom: this.selectedRoom,
          selectedOTA: this.selectedOTA
        })
      );
      await sale_room
        .getAllRelation(body)
        .then(res => {
          if (res.responseCode === 0) {
            // Lấy data hiển thị cho table
            this.relationData = res.data;
            this.relationData.forEach(re => {
              re.availByDate = this.groupBy(re.availabilities, 'appliedDate')
              if (re.ratePlans.length > 0) {
                re.ratePlans.forEach(rp => {
                  if (rp.restrictions.length > 0) {
                    rp.restrictionsGroupBy = this.groupBy(rp.restrictions, 'appliedDate');
                  } else {
                    rp.restrictionsGroupBy = [];
                  }
                })
              }
            })
            // // Lấy data hiển thị list phòng, nếu sẻch thì ko cập nhật lại list phòng
            // if (!isSearch) {
            //   this.loadListRoom(res.data);
            // }
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => {
          setTimeout(() => {
            (this.isLoading = false)
          }, 500);
        });
    },
    getAllPlanByRateCategory() {
      sale_room
        .getAllRatePlanByCategory()
        .then((res) => {
          const data = [];
          res.data.forEach(e => {
            if (e.ratePlans.length > 0) {
              data.push({
                id: e.rateCategoryId ? e.rateCategoryId : -1,
                label: e.rateCategoryI18ns.find(l => l.lang === this.defaultI18n) ? e.rateCategoryI18ns.find(l => l.lang === this.defaultI18n).name : e.nameVi,
                children: e.ratePlans.map(pl => Object.assign({}, {
                  id: pl.id,
                  label: pl.ratePlanI18n.find(l => l.lang === this.defaultI18n) ? pl.ratePlanI18n.find(l => l.lang === this.defaultI18n).name : pl.nameVi,
                }))
              })
            }
          })
          this.listRatePlanByRateCategory = [...data];
          
          this.getAllRoomByRoomCategory();
        })
    },
    getAllRoomByRoomCategory() {
      sale_room
        .getAllRoomTypeByCategory()
        .then((res) => {
          this.listRoomCategory = res.data.map(x => x.roomCategoryId);
          const data = [];
          res.data.forEach(e => {
            if (e.roomTypes.length > 0) {
              data.push({
                id: e.roomCategoryId ? e.roomCategoryId : -1,
                label: e.roomCategoryI18ns.find(l => l.lang === this.defaultI18n) ? e.roomCategoryI18ns.find(l => l.lang === this.defaultI18n).name : e.nameVi,
                children: e.roomTypes.map(pl => Object.assign({}, {
                  id: pl.id,
                  label: pl.roomTypeI18n.find(l => l.lang === this.defaultI18n) ? pl.roomTypeI18n.find(l => l.lang === this.defaultI18n).name : pl.nameVi,
                }))
              })
            }
          })
          this.listRoomTypeByRoomCategory = [...data];
          const local = localStorage.getItem('roomCalendarSearch') ? JSON.parse(localStorage.getItem('roomCalendarSearch')) : null
          const queryString = window.location.href;
          const ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
          if (local && ob.hotel.id === local.hotelId) {
            const allElementsInArray = local.selectedRoom.every(element => this.listRoomTypeByRoomCategory.map(e => e.id).includes(element));
            if(allElementsInArray) {
              this.selectedRoom = local.selectedRoom;
              this.selectedSalePackage = local.selectedSalePackage;
              if (new Date(local.from) >= new Date() ) {
                this.selectedDatePicker = local.from
              } else {
                this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD")
              }
            } else {
              this.selectedRoom = this.listRoomTypeByRoomCategory.map(e => e.id);
              this.selectedSalePackage = this.listRatePlanByRateCategory.map(e => e.id);
              this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD")
            }
          } else {
            this.selectedRoom = this.listRoomTypeByRoomCategory.map(e => e.id);
            this.selectedSalePackage = this.listRatePlanByRateCategory.map(e => e.id);
            this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD")
          }
          
          this.listRoom = [];
          this.listRoomTypeByRoomCategory.forEach(e => {
            e.children.forEach(c => {
              this.listRoom.push({
                value: c.id,
                text: c.label
              });
            })
          });
          this.selectedRoomCalendar = this.listRoom[0].value
        })
    },
    getAllRateCategory() {
      let body = {};
      body.keyword = "";
      body.status = 1;
      body.limit = 99999;
      body.offset = 0;
      body.orderBy = 'ativee';
      body.asc = false;
      categoryService
        .getRateCategoryList(body)
        .then((res) => {
          this.listRateCategory = res.data.map(x => x.id);
          this.getAllPlanByRateCategory();

        })
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    async getOta(isSearch) {
      await syncota.getAllOTA({ keyword: "", status: 1 }).then(res => {
        if (res.responseCode === 0) {
          this.listOTA = res.data.map(x => {
            return {
              value: x.id,
              text: x.otaI18n.find(y => y.lang == this.defaultI18n).name,
              date: this.inDays(new Date(), new Date(x.endDate)),
              endDate: moment(x.endDate).format("DD/MM/YYYY"),
              code: x.otaCode
            };
          });
          this.listOTA = this.listOTA.filter(x => x.value);
          this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
          this.selectedOTA = localStorage.getItem("currentOTARoomSale")
            ? JSON.parse(localStorage.getItem("currentOTARoomSale"))
            : null;
          // Gán OTA đầu tiên để sử dụng lần đầu tiên, với điều kiện có list OTA và chưa tồn tại OTA trong local storage
          if (
            (this.listOTA.length > 0 &&
              this.listOTA[0].value &&
              this.selectedOTA == null) ||
            !this.listOTA.find(x => x.value == this.selectedOTA)
          ) {
            this.selectedOTA = this.listOTA[0].value;
          } else {
            // _alert( 'null', this.$t('OTA_LIST_EMPTY'), false);
          }
          localStorage.setItem(
            "currentOTACodeEdit",
            JSON.stringify(this.listOTA.find(x => this.selectedOTA === x.value).code)
          );
        } else {
          _alert(res, this.$t(res.data), false);
        }
        // this.getRelation(isSearch);
      });
    },
    inDays(d1, d2) {
      var t2 = d2.getTime();
      var t1 = d1.getTime();

      return parseInt((t2 - t1) / (24 * 3600 * 1000));
    },
    changeSearchCondition(value) {
      this.isLoading = true;

      localStorage.setItem(
        "currentOTARoomSale",
        JSON.stringify(this.selectedOTA)
      );
      localStorage.setItem(
        "currentOTACodeEdit",
        JSON.stringify(this.listOTA.find(x => this.selectedOTA === x.value).code)
      );
      this.otaCodeEdit = this.listOTA.find(x => this.selectedOTA === x.value).code
      this.$forceUpdate
        this.getRateCalendar(true);
    },
    nextMonth() {
      this.selectedDatePicker = moment(this.selectedDatePicker)
        .add(31, "day")
        .format("YYYY-MM-DD");
      this.getRelation(true);
    },
    prevMonth() {
      this.selectedDatePicker = moment(this.selectedDatePicker)
        .add(-31, "day")
        .format("YYYY-MM-DD");

      if (
        this.selectedDatePicker <
        moment()
          .startOf("day")
          .format("YYYY-MM-DD")
      ) {
        this.selectedDatePicker = moment()
          .startOf("day")
          .format("YYYY-MM-DD");
      }

      this.getRelation(true);
    },
    addSalePackage(roomId, ratePlans) {
      this.popupSalePackage.roomTypeId = roomId;
      this.popupSalePackage.selectedSalePackage = [];
      this.popupSalePackage.listSalePackage = this.popupSalePackage.listSalePackageDefault;
      this.popupSalePackage.addSalePackageDialog = true;
      // Bỏ các gói bán đã được add trước đó.

      if (ratePlans.length > 0) {
        ratePlans.forEach(e => {
          this.popupSalePackage.listSalePackage = this.popupSalePackage.listSalePackage.filter(
            x => x.value != e.id
          );
        });
      }
    },
    getSalePackage() {
      let body = {
        limit: 100,
        offset: 0,
        keyword: "",
        orderBy: "active",
        asc: true,
        status: 1,
      };
      salePackageService.getAllPlan(body).then((res) => {
        this.popupSalePackage.listSalePackageDefault = res.data.map((x) => {
          return {
            value: x.id,
            text: x.i18ns.find((x) => x.lang == this.defaultI18n).name,
          };
        });
        this.popupSalePackage.listSalePackageDefault = this.popupSalePackage.listSalePackageDefault.filter(
          (x) => x.value
        );
      });
    },
    numberFormat(x) {
      if (x !== null) {
        return new Intl.NumberFormat(this.systemLang, {
            style: 'decimal',
            minimumFractionDigits: this.usedCurrency == 'VND' ? 0 : 2,
            maximumFractionDigits: this.usedCurrency == 'VND' ? 0 : 2,
        }).format(x)
      }
    },
    priceFormat(val) {
      var value =
        Math.abs(val) > 999999 && Math.abs(val) < 1000000000
          ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(2)}M`
          : Math.abs(val) >= 1000000000
            ? `${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(2)}B`
            : Math.abs(val) === 0
              ? `0`
              : `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(2)}K`;
      return value;
    },
    checkWeekend(date) {
      const weekday = ["SUN", "MON", "TUE", "WED", "THU", "FRIFRI", "SAT"];
      let day = weekday[new Date(date).getDay()];
      return this.weekend.includes(day) ? 'd-weekend' : ''
    },
    _moment: moment
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>